/**
 * 住所から県名とそれ以外で切り出す
 *
 * @memberof LocalStorageService
 * @param {string} address
 */
export const AddressSplit = address => {
  const _address = address.match(/^(.{2}[都道府県]|.{3}県)(.*)/);
  if (_address) {
    return {
      prefecture: _address[1],
      other: _address[2],
    };
  }
  return null;
};



// WEBPACK FOOTER //
// ./src/services/utilities/AddressSplit.js